module.exports = __webpack_public_path__ + "media/fonts/SovremennicWide-Bold-390784e70e3eb3d65390f66ca4615934.woff";